import React from 'react';
import { Button } from 'reactstrap';
import './_header.scss';

const ColorLoginUpButton = ({ toggleLogInModal, color }) => (
	<Button
		className="header-login-button"
		color={color || 'primary'}
		style={{ boxShadow: 'none', padding: "0.3rem 0.8rem", fontSize: "0.8rem", marginBottom:'5px' }}
		onClick={toggleLogInModal}
	>
    Log in
	</Button>
);

export default ColorLoginUpButton;
